import { useState } from 'react';
import { Card } from 'react-bootstrap';
import CreateUser from './CreateUserForm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faImagePortrait,
	faMagnifyingGlass,
	faUserPlus,
} from '@fortawesome/free-solid-svg-icons';
import AdminModal from './AdminModal';
import { useNavigate } from 'react-router-dom';

const AdminPanel = () => {
	const navigate = useNavigate();
	const [showModal, setShowModal] = useState(false);

	return (
		<Card id="admin-panel">
			<Card.Body className="d-flex">
				<Card className="clickable-panel" onClick={() => setShowModal(true)}>
					<div className="panel-card-icon">
						<FontAwesomeIcon icon={faUserPlus} className="primaryColor" />
					</div>
					<Card.Body>
						<Card.Title>Create User</Card.Title>
					</Card.Body>
				</Card>
				<Card className="clickable-panel" onClick={() => navigate('/users')}>
					<div className="panel-card-icon">
						<FontAwesomeIcon icon={faImagePortrait} className="primaryColor" />
					</div>
					<Card.Body>
						<Card.Title>Search Users</Card.Title>
					</Card.Body>
				</Card>
				<Card className="clickable-panel" onClick={() => navigate('/view-pnc')}>
					<div className="panel-card-icon">
						<FontAwesomeIcon
							icon={faMagnifyingGlass}
							className="primaryColor"
						/>
					</div>
					<Card.Body>
						<Card.Title>Preliminary Information</Card.Title>
					</Card.Body>
				</Card>
			</Card.Body>

			<AdminModal
				showModal={showModal}
				setShowModal={setShowModal}
				modalTitle="Create User"
			>
				<CreateUser setShowModal={setShowModal} />
			</AdminModal>
		</Card>
	);
};
export default AdminPanel;
